import React from 'react'

import { Alert, Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  pendingToDefineCount: number
  aboveLimitCount: number
  onSuccess: () => void
  onClose: () => void
}

export const CompensationsExportAlertModal = ({
  pendingToDefineCount,
  aboveLimitCount,
  onSuccess,
  onClose,
}: Props) => {
  return (
    <Modal
      illustration="download"
      title={i18n.t('compensations.PayrollRunCompensationsList.export_data')}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.back')}
          </Button>
          <Button type="primary" onClick={onSuccess}>
            {i18n.t('common.export')}
          </Button>
        </>
      }
    >
      <Alert color="warning">
        <Box flexDirection="column" alignItems="flexStart" gap="s8">
          <Box alignItems="center" flexDirection="row" gap="s4" paddingRight="s8">
            <Icon.Large icon="alert" color="champagne1200" />
            <Text.Normal weight="semibold" size="300" color="textPrimary">
              {i18n.t('compensations.PayrollRunCompensationsList.compensations_with_alerts.title')}
            </Text.Normal>
          </Box>
          {pendingToDefineCount > 0 && (
            <Text.Normal size="300" color="textPrimary">
              {i18n.t(
                'compensations.PayrollRunCompensationsList.compensations_with_alerts.pending_to_define_count',
                {
                  count: pendingToDefineCount,
                }
              )}
            </Text.Normal>
          )}
          {aboveLimitCount > 0 && (
            <Text.Normal size="300" color="textPrimary">
              {i18n.t(
                'compensations.PayrollRunCompensationsList.compensations_with_alerts.above_limit_count',
                {
                  count: aboveLimitCount,
                }
              )}
            </Text.Normal>
          )}
        </Box>
      </Alert>
    </Modal>
  )
}
